function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.69414 142.382L57.7325 13.2533C58.4638 11.5375 60.3897 10.6704 62.1591 11.2602C64.1418 11.9211 65.1395 14.1323 64.3232 16.0561L12.2713 138.735C11.6361 140.232 12.7349 141.892 14.3612 141.892H82.8649V128.27C82.8649 126.389 84.3895 124.865 86.2703 124.865C88.151 124.865 89.6757 126.389 89.6757 128.27V162.324C89.6757 164.205 88.151 165.73 86.2703 165.73C84.3895 165.73 82.8649 164.205 82.8649 162.324V148.703H6.87109C3.61523 148.703 1.41752 145.377 2.69414 142.382Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 2.27027
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M260.694 142.166L315.733 13.0372C316.464 11.3214 318.39 10.4542 320.159 11.044C322.142 11.7049 323.14 13.9161 322.323 15.8399L270.271 138.519C269.636 140.016 270.735 141.676 272.361 141.676H340.865V128.054C340.865 126.173 342.39 124.649 344.27 124.649C346.151 124.649 347.676 126.173 347.676 128.054V162.108C347.676 163.989 346.151 165.514 344.27 165.514C342.39 165.514 340.865 163.989 340.865 162.108V148.486H264.871C261.615 148.486 259.418 145.161 260.694 142.166Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 2.27027
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M160.79 21.4575C176.014 24.0615 182.662 23.9984 195.98 21.457C227.39 12.4831 235.519 36.7656 212.701 86.6365C212.234 87.6565 212.582 88.894 213.201 89.8293C218.345 97.6034 216.087 126.949 211.872 140.646C208.729 150.863 200.704 150.863 199.385 140.646C194.845 105.457 191.44 94.1057 178.953 94.1057C166.467 94.1057 163.061 105.457 158.52 140.646C157.202 150.863 149.177 150.863 146.034 140.646C141.819 126.949 139.561 97.6034 144.705 89.8293C145.324 88.894 145.671 87.6544 145.203 86.6349C122.378 36.8545 130.127 16.2955 160.892 21.4749",
  stroke: "black",
  strokeWidth: 6.81081
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M171.406 19.1351C171.406 25.946 167.165 30.8108 162.649 30.8108C158.133 30.8108 153.892 25.946 153.892 19.1351C153.892 12.3242 158.133 7.45946 162.649 7.45946C167.165 7.45946 171.406 12.3242 171.406 19.1351Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2.91892
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 162.811,
  cy: 22.5868,
  rx: 5.83784,
  ry: 7.50579,
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M205.459 19.1351C205.459 25.946 201.219 30.8108 196.703 30.8108C192.186 30.8108 187.946 25.946 187.946 19.1351C187.946 12.3242 192.186 7.45946 196.703 7.45946C201.219 7.45946 205.459 12.3242 205.459 19.1351Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2.91892
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 196.703,
  cy: 22.2626,
  rx: 5.83784,
  ry: 7.50579,
  fill: "black"
});

var SvgError404 = function SvgError404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 168,
    viewBox: "0 0 349 168",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error404.33eda5ab.svg";
export { ForwardRef as ReactComponent };